import { render, staticRenderFns } from "./Oneclick.vue?vue&type=template&id=7e64e0bd&scoped=true&"
import script from "./Oneclick.vue?vue&type=script&lang=js&"
export * from "./Oneclick.vue?vue&type=script&lang=js&"
import style0 from "./Oneclick.vue?vue&type=style&index=0&id=7e64e0bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e64e0bd",
  null
  
)

export default component.exports